<i18n>
{
  "fr": {
    "resource-snippet-consult": "Consulter"
  },
  "en": {
    "resource-snippet-consult": "Consult"
  }
}
</i18n>

<template>
  <component
    :is="link.key ? 'prismic-link' : 'div'"
    :field="link"
    class="resource-snippet has-text-black-ter"
    :class="{ 'p-12px': !$media.widescreen, 'p-24px': $media.widescreen }"
  >
    <span class="resource-snippet__border"></span>
    <span class="resource-snippet__vertical has-max-width-320 mx-auto is-relative has-text-centered">
      <span class="is-block is-hidden-print" :class="{ 'my-24px': $media.mobile, 'my-48px': $media.tablet }">
        <img v-if="image" :src="image" class="resource-snippet__img" />
      </span>
      <span class="resource-snippet__vertical">
        <span class="mb-12px has-text-weight-medium">{{ title }}</span>
      </span>
    </span>
  </component>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      required: true
    },
    image: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">
.resource-snippet {
  display: flex;
  position: relative;
  width: 100%;

  &__border {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid $grey;
    border-radius: 6px;
    opacity: 0.5;
  }

  &:hover &__border,
  &:focus &__border {
    opacity: 1;
  }

  &__vertical {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  &__img {
    display: block;
    height: 80px;
    width: auto;
    margin: 0 auto;
  }
}
</style>